(function () {
  const ORANGE = "rgb(238, 148, 65)";
  const PREORDER_TEXT = "Tellitav";

  function isComingSoonText(text) {
    const t = (text || "").toLowerCase();
    return t.includes("saabumas") || t.includes("eeldatav saabumisaeg");
  }

  function initSection(sectionEl) {
    let scheduled = false;
    let isApplying = false;

    function apply() {
      scheduled = false;
      if (isApplying) return;

      const inventoryEl = sectionEl.querySelector('[id^="Inventory-"]');
      if (!inventoryEl) return;

      // Never override coming soon output
      if (isComingSoonText(inventoryEl.textContent)) return;

      const preorderActive = !!sectionEl.querySelector(
        '.essential-preorder-container-active[data-essential-preorder-element="container"]'
      );

      // If preorder isn't active for the currently selected variant, do nothing.
      // (Theme will show Laos / Laost otsas correctly.)
      if (!preorderActive) return;

      const currentText = (inventoryEl.textContent || "").trim();

      // If it's already showing preorder text, just ensure the dot is orange.
      if (currentText.includes(PREORDER_TEXT)) {
        const icon = inventoryEl.querySelector(".svg-wrapper");
        if (icon) icon.style.color = ORANGE;
        return;
      }

      // Otherwise, set preorder label + orange dot
      isApplying = true;

      const icon = inventoryEl.querySelector(".svg-wrapper");

      inventoryEl.textContent = ""; // clear
      if (icon) {
        icon.style.color = ORANGE;
        inventoryEl.appendChild(icon);
      }
      inventoryEl.appendChild(document.createTextNode(PREORDER_TEXT));

      isApplying = false;
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(apply);
    }

    // Run once on load
    schedule();

    // Observe DOM changes (variant switching + app injection)
    const observer = new MutationObserver(schedule);
    observer.observe(sectionEl, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();